import { S, Icon } from '../regureStyles';

const Header = ({t, onlineUsers, reggieCount, metricFlash, lastUpdated, fetchDashboard }) => {
  return (
    <header
      style={{
        padding: '20px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        background: 'rgba(255,255,255,0.85)',
        backdropFilter: 'blur(20px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <div>
        <div style={{ fontSize: 12, color: S.textMuted, marginBottom: 4 }}>{t('dashboard.intelligence')}</div>
        <div style={{ fontSize: 22, fontWeight: 700, color: S.textPrimary }}>{t('dashboard.operationsDashboard')}</div>
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        {/* Online users pill */}
        {onlineUsers.length > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 5, padding: '4px 10px', background: '#f0fdf4', border: '1px solid #86efac', borderRadius: 20 }}>
            <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', flexShrink: 0 }} className='dash-pulse' />
            <span style={{ fontSize: 12, color: '#15803d', fontWeight: 600 }}>
              {onlineUsers.length} {t('dashboard.online')}
            </span>
          </div>
        )}
        {/* Reggie counter */}
        {reggieCount > 0 && (
          <div
            className={metricFlash.reggieCount ? 'dash-flash' : ''}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              padding: '4px 10px',
              background: 'rgba(128,0,32,0.05)',
              border: '1px solid rgba(128,0,32,0.2)',
              borderRadius: 20,
            }}
          >
            <Icon name='cpu' color={S.burgundy} size={12} />
            <span style={{ fontSize: 12, color: S.burgundy, fontWeight: 600 }}>
              {reggieCount} AI {reggieCount === 1 ? t('dashboard.query') : t('dashboard.queries')}
            </span>
          </div>
        )}
        <div style={{ fontSize: 12, color: S.textMuted }}>
          <Icon name='clock' color={S.textMuted} size={13} /> {lastUpdated ? `${t('dashboard.updatedAt')} ${lastUpdated}` : t('common.loading')}
        </div>
        <button
          onClick={fetchDashboard}
          style={{
            padding: '9px 16px',
            background: S.bgCard,
            border: `1px solid ${S.borderLight}`,
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 500,
            color: S.textSecondary,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: 6,
          }}
        >
          <Icon name='refresh' color={S.textMuted} size={14} /> {t('dashboard.refresh')}
        </button>
        <div style={{ position: 'relative', cursor: 'pointer', padding: 8 }}>
          <Icon name='bell' color={S.textMuted} size={20} />
          <span style={{ position: 'absolute', top: 4, right: 4, width: 8, height: 8, borderRadius: '50%', background: '#ef4444', border: '2px solid #fff' }} />
        </div>
      </div>
    </header>
  );
};

export default Header;
